import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import './OrderReport.scss';
import agentProfile from '../../../assets/placeholder.jpg';
import { AiFillStar } from 'react-icons/ai';
import { FiClock, FiShield, FiFileText } from 'react-icons/fi';
import ReasonForPurchase from './forms/ReasonForPurchase';
import ChoosePackage from './forms/ChoosePackage';
import { Button } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import base from '../../../apis';
import { Elements, useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { getTier } from '../../../utils/functions';
import { URL } from '../../../constants';
import avatar from '../../../assets/placeholder.jpg'


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);


export default function OrderReport({
    agent = {
        name: 'Esther Moses',
        role: 'BPO Homes Premier Agent',
        rating: 4.86,
        reviewsCount: 7,
        avatar: agentProfile,
    },
    defaultReason = '',
    onContinue,
    onPrevious,
}) {

    const { agentId } = useParams();

    const [reason, setReason] = useState(defaultReason);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [agentDetails, setAgentDetails] = useState(null);
    const [bpoModal, setBpoModal] = useState(false);
    const [propertyAddress, setPropertyAddress] = useState('');
    const loggedIn = useSelector((state) => state?.auth?.token?.access);
    const clientId = useSelector((state) => state?.auth?.typeId);

    const [termsAgreed, setTermsAgreed] = useState(true);
    const isClient = useSelector((state) => state.auth.role === 'client');

    const [tierPrices, setTierPrices] = useState([]);

    const [selectedOption, setSelectedOption] = useState('onetime');
    const [selectedSub, setSelectedSub] = useState(null);
    const [searchParams] = useSearchParams();
    const [driveThroughOpen, setDriveThroughOpen] = useState(false);
    const [driveThroughTotal, setDriveThroughTotal] = useState(0);
    const [isSubscription, setIsSubscription] = useState(false);
    const [distanceDetails, setDistanceDetails] = useState({
        clientAddress: '',
    });
    const [step, setStep] = useState(0);
    const dispatch = useDispatch();
    const [otherText, setOtherText] = useState('');
    const client_reason = searchParams.get('client_reason');

    const navigate = useNavigate();

    // Expose Stripe pay from child via ref so we can trigger it on last step
    const stripePayRef = useRef(null);

    useEffect(() => {
        setIsLoading(true);
        const controller = new AbortController();

        axios
            .get(URL + 'register/agents/' + agentId, {
                signal: controller.signal,
            })
            .then(({ data }) => {
                setAgentDetails(data);
            })
            .catch((err) => {
                if ('detail' in err?.response?.data) {
                    navigate('/404', { replace: true });
                }
                toast.error('Could not get agent');
            })
            .finally(() => {
                setIsLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [agentId, navigate]);



    useEffect(() => {
        const price = tierPrices.find((item) => item?.price_id === selectedPackage?.id);
        setSelectedSub(price);
    }, [selectedPackage])


    const currentPage = [
        <ReasonForPurchase key={1} setReason={setReason} reason={reason} />,
        <ChoosePackage key={2} tierPrices={tierPrices} isSubscription={isSubscription} setIsSubscription={setIsSubscription} onetime={Number(agentDetails?.discount_value || agentDetails?.report_price)} selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} />
    ]




    useEffect(() => {
        if (step === 1) {
            (async () => {
                const requestString = JSON.parse(localStorage.getItem('request'))
                const request = {
                    ...requestString,
                    reason_for_request: reason,
                    payment_status: 'Complete',
                }
                try {
                    const { data } = await base.post('/register/check_client_report_status/', request)
                    let route;
                    if ('id' in data) {
                        route = `/client-ordered-report?id=${data.id}`;
                        navigate(route);
                        return;
                    }
                } catch (error) {

                }


            })()
        }
    }, [step])


    // payment details 
    useEffect(() => {
        if (!isClient) {
            toast.warn('Only clients can request a bpo report');
            navigate('/agent-dashboard');
            return;
        }
        const mode = searchParams.get('mode');
        if (mode) {
            setSelectedOption(mode);
        }

        const getDetails = async () => {
            setIsLoading(true);
            try {
                const {
                    data: {
                        report_price,
                        first_name,
                        last_name,
                        discount_value,
                        discount_percent,
                        distance_flat_fee,
                        drive_through_address,
                        flat_fee,
                        price_per_mile,
                    },
                } = await base.get(`/register/agents/${agentId}/`);
                // setAgentDetails({
                //     report_price,
                //     name: `${first_name} ${last_name}`,
                //     discount_value,
                //     discount_percent,
                //     distance_flat_fee,
                //     drive_through_address,
                //     flat_fee,
                //     price_per_mile,
                // });
                const { data: prices } = await base.get('/register/list_prices/', {
                    params: {
                        product: 'bpo_report_tier',
                    },
                });
                const tier = getTier(report_price);

                if (prices?.flat().length !== 0) {
                    const Prices = prices
                        ?.flat()
                        .filter((item) => item?.metadata?.tier === tier)
                        .map((item) => ({
                            amount: item?.unit_amount / 100,
                            description: item?.nickname,
                            price_id: item?.id,
                            number_of_report: item?.metadata?.report,
                            tier: item?.metadata?.tier,
                        }))
                        .sort((a, b) => a.amount - b.amount);
                    setTierPrices(Prices);
                }
                if (drive_through_address && distance_flat_fee && flat_fee) {
                    const reportAddress = JSON.parse(localStorage.getItem('request'))?.propertyAddress;
                    setDistanceDetails((cur) => ({ ...cur, clientAddress: reportAddress }));
                    setIsLoading(true);
                    try {
                        const { data } = await base.get('/leads/get_delivery_distance/', {
                            params: {
                                agent_address: drive_through_address,
                                client_address: reportAddress,
                            },
                        });
                        const items = {
                            distance: data?.distance,
                            distance_after_flat_fee: data?.distance > distance_flat_fee ? data?.distance - distance_flat_fee : 0,
                            amount_after_flat_fee: 0,
                        };
                        if (items.distance_after_flat_fee) {
                            items.amount_after_flat_fee = items.distance_after_flat_fee * price_per_mile;
                        }
                        setDistanceDetails((cur) => ({ ...cur, ...items }));
                        setStep(1);
                    } catch (error) {
                        toast.warn('Could not get distance details');
                    } finally {
                        setIsLoading(false);
                    }
                } else {

                }
            } catch (error) {
                toast.warn('Something went wrong');
            } finally {
                setIsLoading(false);
            }
        };

        getDetails();
    }, [agentId, isClient, navigate, searchParams]);



    return (
        <div className="order-report">
            <Elements stripe={stripePromise}>
                <div className="or-left">

                    <div className="agent-row">
                        <img className="avatar" src={agentDetails?.profile_image || avatar} alt={`${agentDetails?.first_name} profile`} />
                        <div className="meta">
                            <div className="name">{agentDetails?.first_name} {agentDetails?.last_name}</div>
                            <div className="role">{agentDetails?.agent_status}</div>
                            <div className="rating">
                                <AiFillStar className="star" aria-hidden />
                                <span className="score">{agent.rating.toFixed(2)}</span>
                                <span className="sep">Based on</span>
                                <button className="reviews-link" type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                    {agent.reviewsCount} reviews
                                </button>
                            </div>
                        </div>
                    </div>

                    <ul className="benefits" aria-label="Benefits">
                        <li><FiClock aria-hidden size={30} className='icons' /><span>Fast 24–48 hour delivery</span></li>
                        <li><FiShield aria-hidden size={30} className='icons' /><span>Licensed professionals only</span></li>
                        <li><FiFileText aria-hidden size={30} className='icons' /><span>Comprehensive market analysis</span></li>
                    </ul>

                </div>

                <div className="or-right">
                    {currentPage[step]}
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='contained' disabled={step === 0} onClick={() => setStep(p => p - 1)}>Previous</Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                const lastStep = currentPage.length - 1;
                                if (step < lastStep) {
                                    setStep(p => p + 1);
                                } else {
                                    // At last step: trigger Stripe payment
                                    stripePayRef.current?.confirmPayment();
                                }
                            }}
                        >
                            Save & Continue
                        </Button>
                    </div>
                </div>
                <div>

                </div>
                {/* Mount StripePay always (hide its button until last step) so parent can trigger payment */}
                <StripePay
                    ref={stripePayRef}
                    termsAgreed={termsAgreed}
                    agentId={agentId}
                    selectedPrice={selectedSub}
                    isSub={isSubscription}
                    tier={getTier(agentDetails?.report_price)}
                    driveThroughTotal={driveThroughTotal}
                    hideButton={step !== (currentPage.length - 1)}
                />
            </Elements>
        </div>
    );
}

OrderReport.propTypes = {
    agent: PropTypes.shape({
        name: PropTypes.string,
        role: PropTypes.string,
        rating: PropTypes.number,
        reviewsCount: PropTypes.number,
        avatar: PropTypes.string,
    }),
    defaultReason: PropTypes.string,
    onContinue: PropTypes.func,
    onPrevious: PropTypes.func,
};


const StripePay = forwardRef(({ termsAgreed, selectedPrice, isSub, agentId, tier, driveThroughTotal, hideButton }, ref) => {
    const stripe = useStripe();

    const confirmPayment = () => {
        if (!termsAgreed) {
            toast.warn('Please agree to the terms and conditions');
            return;
        }

        if (isSub && !selectedPrice) {
            toast.warn('Please select a price');
            return;
        }

        const body = {
            cancel_url: `${window.location.origin}/report-pay/` + agentId,
            success_url: `${window.location.origin}/payment_success?type=bpo-report&agent_id=${agentId}&tier=${tier}${'&num_of_report=' + (selectedPrice?.number_of_report || 1)
                }&mode=${isSub ? 'subscription' : 'one_time'}&`,
            mode: 'payment',
            payment_type: isSub ? 'monthly' : 'one_time',
            package: 'bpo_report_tier',
            payment_method_types: ['card'],
        };

        const extra_data = {
            agent_id: agentId,
            tier: tier,
            product: 'bpo_report_tier',
        };
        if (driveThroughTotal > 0) {
            extra_data['drive_amount'] = driveThroughTotal;
        }

        if (isSub) {
            extra_data['number_of_report'] = selectedPrice?.number_of_report;
            extra_data['price'] = selectedPrice?.price_id;
            body['interval'] = 'monthly';
            body['mode'] = 'subscription';
        } else {
            extra_data['number_of_report'] = 1;
        }

        body['extra_data'] = [extra_data];

        base
            .post('/register/create_subscription/', body)
            .then(({ data: { sessionId } }) => {
                if (!sessionId) {
                    toast.error('Something went wrong');
                    return;
                }
                stripe.redirectToCheckout({ sessionId });
            })
            .catch((err) => {
                toast.error('Something went wrong');
            });
    };

    useImperativeHandle(ref, () => ({ confirmPayment }));

    if (hideButton) return null;

    return (
        <></>
    );
});
